'use strict';
import angular from 'angular';

export default class AppFrameController {
  /*@ngInject*/
  constructor($stateParams, $http, $state, Application, $scope, Upload) {
    var vm = this;
    vm.rows = [];
    vm.fileUploadTime = Date.now();

    $http.get('/api/applications/' + $stateParams.id).then(
      function(res) {
        var data = res.data;
        Application.load($stateParams.id).then(function() {
          $scope.$apply(function() {
            vm.app = Application;
            vm.rows = Application.general.frames;
          });
        });
      },
      function(error) {
        if (error.status == "404") {
          $state.go('application_main');
        }
        console.log(error);
      });

    vm.save = function() {
      Application.save($stateParams.id);
    }

    vm.upload = function(file, name) {
      Upload.upload({
        url: '/api/applications/' + $stateParams.id + '/upload/' + name,
        data: { file: file }
      }).then(function(resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.fileUploadTime = Date.now();
      }, function(resp) {
        console.log('Error status: ' + resp.status);
      }, function(evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    };

    vm.uploadElem = function(file, path) {
      Upload.upload({
        url: '/api/applications/' + $stateParams.id + '/upload',
        data: { file: file, path: path, width: 1772, height: 1181, ext: '.png' }
      }).then(function(resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.fileUploadTime = Date.now();
        Application.save($stateParams.id);
      }, function(resp) {
        console.log('Error status: ' + resp.status);
      }, function(evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    };
  }

}



// WEBPACK FOOTER //
// ./client/app/application/frame/frame.controller.js